import { Create } from "@material-ui/icons";
import { observer } from "mobx-react-lite";
import React, { useCallback, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import api from "../../api";
import { APIProjectCreateInput } from "../../api/projects";
import Button from "../../components/Button";
import history from "../../services/history";
import { useStore } from "../../store";
import { Toast } from "../../utils";
import ProjectNameForm from "./ProjectNameForm";

type Props = {
  slug?: string;
  isOpen: boolean;
  setModal: (visible: boolean) => void;
};

const NewProject: React.FC<Props> = ({ slug, isOpen, setModal }) => {
  const methods = useForm();
  const urlPrefix = "/projects/";
  const store = useStore();
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = useCallback(
    async (data: APIProjectCreateInput) => {
      setSubmitting(true);
      try {
        const { id } = await store.projects.create(data, slug);
        history.push(`${urlPrefix}${id}/settings/details/`);
      } catch (errorResponse: any) {
        const { detail } = await api.handleError(errorResponse);
        if (errorResponse.description !== "Unauthorized") {
          if (detail) {
            Object.entries(detail!).forEach(([key, message]) => {
              methods.setError(key as any, {
                message: (message as string[])[0],
              });
            });
          }
          setSubmitting(false);
          return;
        }
      }
      setModal(false);
      Toast.success("Project Created");
    },
    [urlPrefix, slug, store, methods, setModal]
  );

  return (
    <FormProvider {...methods}>
      <ProjectNameForm
        isOpen={isOpen}
        setModal={setModal}
        headerText="Create New Project"
        disabled={submitting}
        submitButton={
          <Button type="submit" disabled={submitting}>
            <Create /> {submitting ? "Creating..." : "Create"}
          </Button>
        }
        onSubmit={handleSubmit}
      />
    </FormProvider>
  );
};

export default observer(NewProject);
